import box from './Box';
import center from './Center';
import flex from './Flex';
import title from './Title';
import grid from './Grid';
import section from './Section';
import aspect from './Aspect';
import image from './Img';
import input from './Input';
import button from './Button';
import label from './Label';
import video from './Video';
import iframe from './IFrame';
import select from './Select';
import option from './Option';
import file from './File';

export const Box = box
export const Center = center
export const Flex = flex
export const Title = title
export const Grid = grid
export const Section = section
export const Aspect = aspect
export const Img = image
export const Input = input
export const Button = button
export const Label = label
export const Video = video
export const IFrame = iframe
export const Select = select
export const Option = option
export const File = file